import { Check } from "lucide-react";
import { decodeHtml } from "../data/helper";

export interface PillItem {
  id: string;
  name: string;
}

interface SubsectionPillsProps {
  subsections: PillItem[];
  currentIndex: number;
  className?: string;
}

export function SubsectionPills({ subsections, currentIndex, className }: SubsectionPillsProps) {
  return (
    <div className={`bg-white border-b border-gray-200 px-6 py-3 ${className ?? ""}`}>
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {subsections.map((sub, idx) => (
          <div
            key={sub.id}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition ${idx === currentIndex
              ? "bg-primary text-on-primary"
              : idx < currentIndex
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-500"
              }`}
          >
            <div
              className={`flex items-center justify-center w-4 h-4 rounded-full text-xs ${idx === currentIndex
                ? "bg-white text-gray-900"
                : idx < currentIndex
                  ? "bg-green-600 text-white"
                  : "bg-gray-300 text-gray-600"
                }`}
            >
              {idx < currentIndex ? (
                <Check className="w-2.5 h-2.5" />
              ) : (
                <span className="text-xs">{idx + 1}</span>
              )}
            </div>
            <span className="text-xs whitespace-nowrap">
              {decodeHtml(sub.name)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SubsectionPills;
